import React from "react";
import { toast } from "sonner";
import { CalendarCheck } from "lucide-react";
import { api, apiError } from "../../lib/api";

export const Plan30 = ({ steps, onSaved, basePath = "/academia" }) => {
  const toggle = async (step) => {
    try {
      const { data } = await api.post(`${basePath}/plan30`, { step_id: step.step_id, done: !step.done });
      onSaved(data);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="plan30-section" className="rounded-2xl border border-white/10 bg-emerald-950/60 p-5">
      <div className="flex items-center gap-2 mb-1">
        <CalendarCheck size={18} className="text-yellow-400" />
        <h2 className="font-bold text-lg text-zinc-100">Plan práctico de 30 días</h2>
      </div>
      <p className="text-xs text-zinc-400 mb-4">Marca cada etapa cuando la completes en la vida real.</p>
      <div className="space-y-2">
        {steps.map((s) => (
          <label key={s.step_id} data-testid={`plan30-${s.step_id}`} className="flex items-start gap-3 rounded-xl bg-black/25 border border-white/10 px-4 py-3 cursor-pointer hover:border-yellow-400/40 transition-colors">
            <input
              type="checkbox"
              data-testid={`plan30-check-${s.step_id}`}
              checked={!!s.done}
              onChange={() => toggle(s)}
              className="mt-0.5 h-4 w-4 accent-yellow-400"
            />
            <span className={`text-sm ${s.done ? "text-emerald-300 line-through" : "text-zinc-200"}`}>{s.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
